<template>
    <div v-loading="fullscreenLoading">
        <!--收货地址-->
        <div class="item-block" v-if="orderPaymentData.is_virtual == 0">
            <div class="block-text">收货地址</div>

            <div clsas="address-list">
                <!--<div class="address-item" @click="addAddressShow">
					<div class="add-address">
						<i class="el-icon-circle-plus-outline"></i>
						添加收货地址
					</div>
				</div>-->

                <div class="address-item" v-for="(item, key) in memberAddress" :key="item.id"
                    :class="addressId == item.id ? 'active' : ''" v-if="key < 3 || (addressShow && key >= 3)">
                    <div class="address-info">
                        <div class="options">
                            <!--<div @click="editAddress(item.id)">编辑</div>-->
                            <template v-if="item.is_default == 0">
                                <el-popconfirm title="确定要删除该地址吗？" @onConfirm="deleteMemberAddress(item.id)">
                                    <div slot="reference">删除</div>
                                </el-popconfirm>
                            </template>
                        </div>
                        <div class="address-name" @click="setMemberAddress(item.id)">{{ item.name? item.name : '无' }}</div>
                        <div class="address-mobile" @click="setMemberAddress(item.id)">{{ item.mobile? item.mobile : '无' }}</div>
                        <div class="address-desc" @click="setMemberAddress(item.id)">
                            {{ item.full_address? item.full_address : '无'}}
                            {{ item.address? item.address : '无' }}
                        </div>
                    </div>
                </div>
                <div v-if="memberAddress.length > 3 && !addressShow" @click="addressShow = true"
                    class="el-button--text address-open">
                    <i class="el-icon-arrow-down"></i>
                    更多收货地址
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <!--购买虚拟类商品需填写您的手机号-->
        <div class="item-block" v-if="orderPaymentData.is_virtual == 1">
            <div class="block-text">购买虚拟类商品需填写您的手机号，以方便商家与您联系</div>

            <el-form ref="form" size="mini" class="mobile-wrap" label-width="80px">
                <el-form-item label="手机号码">
                    <el-input placeholder="请输入您的手机号码" maxlength="11"
                        v-model="orderCreateData.member_address.mobile"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <!--收货地址添加-->
        <el-dialog :title="addressForm.id == 0 ? '添加收货地址' : '编辑收货地址'" :visible.sync="dialogVisible" width="32%">
            <el-form ref="form" :rules="addressRules" :model="addressForm" label-width="80px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="addressForm.name" placeholder="收货人姓名"></el-input>
                </el-form-item>

                <el-form-item label="手机" prop="mobile">
                    <el-input v-model="addressForm.mobile" maxlength="11" placeholder="收货人手机号"></el-input>
                </el-form-item>

                <el-form-item label="电话">
                    <el-input v-model="addressForm.telephone" placeholder="收货人固定电话（选填）"></el-input>
                </el-form-item>

                <el-form-item class="area" label="地区" prop="area">
                    <el-row :gutter="10">
                        <el-col :span="7">
                            <el-select prop="province" ref="province" v-model="addressForm.province_id"
                                @change="getAddress(1)" placeholder="请选择省">
                                <el-option label="请选择省" value="0"></el-option>
                                <el-option v-for="item in pickerValueArray" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="7">
                            <el-select ref="city" prop="city" v-model="addressForm.city_id" @change="getAddress(2)"
                                placeholder="请选择市">
                                <el-option label="请选择市" value="0"></el-option>
                                <el-option v-for="item in cityArr" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="7">
                            <el-select ref="district" prop="district" v-model="addressForm.district_id"
                                placeholder="请选择区/县">
                                <el-option label="请选择区/县" value="0"></el-option>
                                <el-option v-for="item in districtArr" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="addressForm.address" placeholder="定位小区、街道、写字楼"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addmemberAddress('form')">确 定</el-button>
            </span>
        </el-dialog>

        <!--使用余额-->
        <!-- <div class="item-block" v-if="orderPaymentData.member_account.balance_total > 0 && balance_show == 1">
            <div class="block-text">是否使用余额</div>
            <div class="pay-type-list">
                <div class="pay-type-item" :class="orderCreateData.is_balance ? '' : 'active'" @click="useBalance(0)">
                    不使用余额
                </div>
                <div class="pay-type-item" :class="orderCreateData.is_balance ? 'active' : ''" @click="useBalance(1)">
                    使用余额
                </div>
                <div class="clear"></div>
            </div>
        </div> -->

        <!--使用积分抵扣-->
        <div class="item-block" v-if="orderPaymentData.shop_goods_list.max_usable_point > 0">
            <div class="block-text">是否使用积分</div>

            <div class="pay-type-list">
                <div class="pay-type-item" :class="orderCreateData.is_point ? '' : 'active'" @click="usePoint(0)">
                    不使用积分
                </div>
                <div class="pay-type-item" :class="orderCreateData.is_point ? 'active' : ''" @click="usePoint(1)">
                    使用积分
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <!-- 配送方式 -->
        <div class="item-block padd-bom-20" v-if="orderPaymentData.shop_goods_list.express_type.length > 1">
            <div class="block-text">
                配送方式
                <span class="distribution" v-if="orderPaymentData.delivery_type == 'store'">{{
                    orderCreateData.delivery.store_name }}</span>
            </div>
            <div class="pay-type-item"
                v-for="(deliveryItem, deliveryIndex) in orderPaymentData.shop_goods_list.express_type"
                :key="deliveryIndex"
                @click="selectDeliveryType(deliveryItem, orderPaymentData.site_id, orderPaymentData.shop_goods_list.express_type)"
                :class="orderPaymentData.delivery_type == deliveryItem.name ? 'active' : ''"
                v-if="deliveryItem.name != 'local'">
                {{ deliveryItem.title }}
            </div>
        </div>

        <!-- 履约配置 -->
        <div class="item-block fulfillment-block" v-if="orderPaymentData.is_virtual == 0">
            <div class="block-text">订单配置</div>
            <div class="fulfillment-grid">
                <div class="fulfillment-card"
                    v-if="orderPaymentData.select_delivery_status"
                    :class="{ 'is-empty': !expressCompanyItem }"
                    @click="openExpressCompany">
                    <div class="fulfillment-card-main">
                        <div class="fulfillment-icon">
                            <i class="el-icon-truck"></i>
                        </div>
                        <div class="fulfillment-content">
                            <div class="fulfillment-label">物流公司</div>
                            <div class="fulfillment-value">{{ selectedExpressCompanyName }}</div>
                        </div>
                    </div>
                    <div class="fulfillment-extra">
                        <el-tag size="mini" :type="expressCompanyItem ? 'success' : 'warning'">
                            {{ expressCompanyItem ? '已选择' : '待选择' }}
                        </el-tag>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>

                <div class="fulfillment-card inspection-report-card" @click="openInspectionReport">
                    <div class="fulfillment-card-main">
                        <div class="fulfillment-icon">
                            <i class="el-icon-document-checked"></i>
                        </div>
                        <div class="fulfillment-content">
                            <div class="fulfillment-label">质检报告</div>
                            <div class="fulfillment-value">{{ selectedInspectionReportName }}</div>
                            <div class="fulfillment-desc">{{ selectedInspectionReportDesc }}</div>
                        </div>
                    </div>
                    <div class="fulfillment-extra">
                        <el-tag size="mini" :type="inspection_report_type == '0' ? 'info' : 'success'">
                            {{ inspection_report_type == '0' ? '默认' : '已选择' }}
                        </el-tag>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="item-block" v-if="orderPaymentData.shop_goods_list.invoice">
            <div class="block-text">发票信息</div>
            <div class="pay-type-list">
                <el-radio-group v-model="orderCreateData.receipt_type">
                    <template v-for="(item) in invoiceRadio">
                        <el-radio :label="item.value" @change="clickType(item.value)">{{ item.name }}</el-radio>
                    </template>
                </el-radio-group>
            </div>
        </div>

        <!--商品信息-->
        <div class="item-block">
            <div class="goods-list">
                <table>
                    <tr style="display: flex; flex-wrap: wrap; width: 100%">
                        <td style="flex: 0 0 50%" width="12.5%">商品</td>
                        <td style="flex: 1" width="12.5%">价格</td>
                        <td style="flex: 1" width="12.5%">数量</td>
                        <td style="flex: 1" width="12.5%">小计</td>
                    </tr>
                </table>
            </div>
        </div>
        <div>
            <div class="item-block">
                <div class="goods-list">
                    <table>
                        <tr style="display: flex; flex-wrap: wrap; width: 100%"
                            v-for="(goodsItem, goodsIndex) in orderPaymentData.shop_goods_list.goods_list"
                            :key="goodsIndex">
                            <td style="flex: 0 0 50%" width="50%">
                                <div class="goods-info">
                                    <goods-info :item="goodsInfoAdpter(goodsItem)"></goods-info>
                                </div>
                            </td>
                            <td style="flex: 1" width="12.5%" class="goods-price">
                                <template v-if="verifyActiveGoods(goodsItem)">
                                    <div class="price_new">
                                        <div class="class_1">
                                            <span>￥</span>
                                            <span>{{ goodsPrice(goodsItem).real_price }}</span>
                                            <span v-if="goodsItem.unit">/{{ goodsItem.unit }}</span>
                                        </div>
                                        <div class="class_2" v-if="goodsPrice(goodsItem).original_price>0">
                                            <span>￥</span>
                                            <span>{{ goodsPrice(goodsItem).original_price }}</span>
                                            <span v-if="goodsItem.unit">/{{ goodsItem.unit }}</span>
                                        </div>
                                    </div>
                                </template>
                               <template v-else>
                                    <cartAndOrder_price :showBold="true" :info="goodsItem"></cartAndOrder_price>
                               </template>
                            </td>
                            <td style="flex: 1" width="12.5%" class="goods-num">
                                {{ goodsItem.num }}
                            </td>
                            <template v-if="verifyActiveGoods(goodsItem)">
                                <td style="flex: 1" width="12.5%" class="goods-money">
                                    <div class="price_new_2">
                                        <div class="class_1">
                                            <span>￥</span>
                                            <span>{{ goodsPrice(goodsItem).total_real_price }}</span>
                                        </div>
                                        <div class="class_2">
                                            <div>
                                                <span>￥</span>
                                                <span>{{ goodsPrice(goodsItem).total_original_price }}</span>
                                            </div>
                                            <div v-if="goodsPrice(goodsItem).total_discount_price>0">
                                                <span>优惠</span>
                                                <span>￥</span>
                                                <span>{{ goodsPrice(goodsItem).total_discount_price }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </template>
                            <template v-else>
                                <td style="flex: 1;font-weight: bold;" width="12.5%" class="goods-money">
                                    ￥{{ calculationOfPrice(goodsItem) }}
                                </td>
                            </template>
                            <template v-if="returnShowFreeGoods(goodsItem)">
                                <td style="flex: 0 0 100%; width: 0">
                                    <h4>请选择换购商品：</h4>
                                    <div class="free-goods-content">
                                        <template v-for="(exchengeItem, exchangeindex) in goodsItem.get_goods_free.getFreeGoods">
                                            <div v-if="goodsItem.num >= exchengeItem.count"
                                                @click="goodsFreeChoice(exchengeItem, exchangeindex, goodsIndex, goodsItem)"
                                                :class="['goods-content', { 'goods-content-checked': exchengeItem.checked }]">
                                                <img alt="" style="width: 100px"
                                                    :src="$img(exchengeItem.goods.goods_image)" />
                                                <div class="freeGoodsAttr">
                                                    <div>
                                                        <div class="freeGoodsAttrItem">{{ exchengeItem.goods.goods_name
                                                            }}
                                                        </div>
                                                        <div class="freeGoodsAttrItem text_color">
                                                            厂家：{{ exchengeItem.attr.attr_factory }}
                                                        </div>
                                                        <div class="freeGoodsAttrItem text_color">
                                                            规格：{{ exchengeItem.attr.attr_specs }}
                                                        </div>
                                                        <div class="freeGoodsAttrItem text_color">
                                                            单价：￥{{ exchengeItem.price }}
                                                        </div>
                                                        <div class="freeGoodsAttrItem text_color">
                                                            数量：
                                                            <span>{{ freeGoodsLimit(goodsItem, exchengeItem) }} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div @click.stop v-if="!exchengeItem.sale_control.is_member_by" class="position_text"> 
                                                    <span>{{ exchengeItem.sale_control.not_buy_msg }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </td>
                            </template>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!--优惠券-->
        <div class="item-block" v-if="orderPaymentData.shop_goods_list.coupon_list.length">
            <div class="block-text">优惠券</div>
            <div class="order-cell platform-coupon">
                <div v-if="parseFloat(orderPaymentData.coupon_money)>0">
                    <span class="ns-text-color" @click="openPlatformCoupon">已选择优惠券，已优惠</span>
                    <span class="ns-text-color" @click="openPlatformCoupon">
                        <span class="inline">￥</span>
                        {{ typeof orderPaymentData.coupon_money == 'number' ? orderPaymentData.coupon_money.toFixed(2) : orderPaymentData.coupon_money }}
                    </span>
                    <span class="ns-text-color" @click="openPlatformCoupon">点击查看</span>
                </div>

                <div v-else>
                    <div class="box ns-text-color" @click="openPlatformCoupon">不使用优惠券</div>
                </div>
            </div>
        </div>

        <!-- 买家留言 -->
        <div class="item-block padd-bom-10">
            <div class="block-text">买家留言:</div>
            <el-input rows="3" type="textarea" placeholder="留言前建议先与商家协调一致" v-model="orderCreateData.buyer_message"
                class="buyer-message" @input="textarea" maxlength="140" show-word-limit resize="none"></el-input>
        </div>
        <!--        <div class="Couponcalculation" v-if="orderPaymentData.coupon_up_info.difference_money != null">-->
        <!--            再购买-->
        <!--            <span> {{ orderPaymentData.coupon_up_info.difference_money }}</span>-->
        <!--            元商品 即可享受-->
        <!--            <span> {{ orderPaymentData.coupon_up_info.coupon_money }}</span>-->
        <!--            元 优惠-->
        <!--            <span @click="qucoudan" style="cursor: pointer">立即去凑单></span>-->
        <!--        </div>-->
        <!-- 总计 -->
        <div class="item-block">
            <div class="order-statistics">
                <table>
                    <tr>
                        <!--                        减去运费-->
                        <td align="right">商品总额：</td>
                        <td align="left" class="colorsize" style="color: #333;font-weight: bold;">
                            ￥{{ commonGoodsAndExchangedGoodsComputedMoney | moneyFormat }}
                        </td>
                    </tr>
                    <tr v-if="orderPaymentData.is_virtual == 0">
                        <td align="right">优惠金额：</td>
                        <td align="left" class="colorsize" style="color: green;font-weight: bold;">-￥{{ (parseFloat(orderPaymentData.coupon_money) + parseFloat(orderPaymentData.promotion_money)).toFixed(2) | moneyFormat }}</td>
                    </tr>
                    <!-- <tr v-if="orderPaymentData.coupon_money > 0">
                        <td align="right">优惠券：</td>
                        <td align="left" class="colorsize">￥{{ orderPaymentData.coupon_money | moneyFormat }}</td>
                    </tr> -->
                    <!-- <tr v-if="orderPaymentData.promotion_money > 0">
                        <td align="right">满减优惠：</td>
                        <td align="left" class="colorsize">￥{{ orderPaymentData.promotion_money | moneyFormat }}</td>
                    </tr> -->
                    <tr v-if="orderPaymentData.is_virtual == 0">
                        <td align="right">运费：</td>
                        <td align="left" class="colorsize" style="font-weight: bold;">+￥{{ orderPaymentData.delivery_money | moneyFormat }}</td>
                    </tr>
                    <tr v-if="orderPaymentData.invoice_money > 0">
                        <td align="right">税费：</td>
                        <td align="left" class="colorsize">￥{{ orderPaymentData.invoice_money | moneyFormat }}</td>
                    </tr>
                    <tr v-if="orderPaymentData.invoice_delivery_money > 0">
                        <td align="right">发票邮寄费：</td>
                        <td align="left" class="colorsize">￥{{ orderPaymentData.invoice_delivery_money | moneyFormat
                            }}
                        </td>
                    </tr>
                    <tr v-if="orderPaymentData.point_money > 0">
                        <td align="right">积分抵现金额：</td>
                        <td align="left" class="colorsize">￥{{ orderPaymentData.point_money | moneyFormat }}</td>
                    </tr>
                    <tr v-if="orderPaymentData.balance_money > 0">
                        <td align="right">使用余额：</td>
                        <td align="left" class="colorsize">￥{{ orderPaymentData.balance_money | moneyFormat }}</td>
                    </tr>
                    <tr v-if="Totaloffera > 0">
                        <td align="right">总计优惠：</td>
                        <td align="left" class="colorsize">￥{{ Totaloffera }}</td>
                    </tr>
                    <tr v-if="orderPaymentData.is_virtual == 0">
                        <td align="right">实付金额：</td>
                        <td align="left" class="colorsize" style="color: #333;font-weight: bold;">￥{{ computedPayMoney | moneyFormat }}</td>
                    </tr>
                </table>
            </div>
            <div class="clear"></div>
        </div>

        <!--结算-->
        <div class="item-block">
            <div class="order-submit">
                <div class="order-money">
                    共{{ orderPaymentData.goods_num }}件，应付金额：
                    <div class="ns-text-color" style="font-weight: bold;">￥{{ computedPayMoney | moneyFormat }}</div>
                    <div style="margin-left: 10px" v-if="isOrderMinBuyMoney">
                        <el-tag type="danger">订单不得小于{{ orderPaymentData.min_buy_money }}元</el-tag>
                    </div>
                </div>
                <el-button type="primary" :disabled="isOrderMinBuyMoney" class="el-button--primary"
                    @click="orderCreate">订单结算
                </el-button>

            </div>
            <div class="clear"></div>
        </div>

        <!--选择平台优惠券弹框-->
        <el-dialog title="选择优惠券" :visible.sync="dialogPlatcoupon" width="50%" @close="savePlatformCoupon()">
            <el-table ref="platformCouponTable" :data="orderPaymentData.shop_goods_list.coupon_list"
                highlight-current-row @row-click="selectPlatformCoupon" class="cursor-pointer">
                <el-table-column label="" width="55">
                    <template slot-scope="scope">
                        <div class="disabled-selected-wrap">
                            <el-radio v-model="platformCouponRadio" :label="scope.row"><i></i></el-radio>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="platformcoupon_name" label="名称" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.coupon_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型" width="150">
                    <template slot-scope="scope">
                        <span>{{ returnCouponText(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="money" label="面额">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type=='discount'">{{ scope.row.discount }}折</span>
                        <span v-else>{{ scope.row.money }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="使用">
                    <template slot-scope="scope">
                        <span class="ns-text-color-gray ns-font-size-sm" v-if="scope.row.at_least > 0">满{{
                            scope.row.at_least }}可用</span>
                        <span class="ns-text-color-gray ns-font-size-sm" v-else>任意金额可用</span>
                    </template>
                </el-table-column>
                <el-table-column label="期限">
                    <template slot-scope="scope">
                        <span>{{ $util.timeStampTurnTime(scope.row.end_time) }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <br />
            <div class="align-right">
                <el-button @click="dialogPlatcoupon = false">取消</el-button>
                <el-button @click="dialogPlatcoupon = false" type="primary">确认选择</el-button>
            </div>
        </el-dialog>
        <!--配送方式  门店 -->
        <el-dialog title="选择门店" :visible.sync="dialogStore" width="50%">
            <el-table ref="singleTable" :data="storeList" highlight-current-row @row-click="selectStore"
                class="cursor-pointer">
                <el-table-column label="" width="55">
                    <template slot-scope="scope">
                        <el-radio v-model="storeRadio" :label="scope.row"><i></i></el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="store_name" label="名称" width="160"></el-table-column>
                <el-table-column prop="store_address" label="地址"></el-table-column>
                <el-table-column prop="open_date" label="营业时间"></el-table-column>
            </el-table>
        </el-dialog>

        <!-- 物流公司 -->
        <el-dialog title="选择物流公司" :visible.sync="dialogExpressCompany" width="520px">
            <div class="express-current">
                当前物流公司：
                <span :class="{ 'ns-text-color': expressCompanyItem }">{{ selectedExpressCompanyName }}</span>
            </div>
            <el-table v-if="expressCompanyList && expressCompanyList.length"
                :data="expressCompanyList"
                highlight-current-row
                @row-click="selectExpressCompany"
                class="cursor-pointer">
                <el-table-column label="" width="55">
                    <template slot-scope="scope">
                        <el-radio :value="selectedExpressCompanyId" :label="scope.row.company_id"><i></i></el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="company_name" label="物流公司"></el-table-column>
                <el-table-column label="状态" width="110">
                    <template slot-scope="scope">
                        <el-tag v-if="selectedExpressCompanyId == scope.row.company_id" size="mini" type="success">当前使用</el-tag>
                        <span v-else class="ns-text-color-gray">可选择</span>
                    </template>
                </el-table-column>
            </el-table>
            <div v-else class="express-empty">
                <i class="el-icon-truck"></i>
                <div>暂无可选物流公司</div>
                <p>请联系管理员维护物流公司</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogExpressCompany = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 质检报告 -->
        <el-dialog title="选择质检报告" :visible.sync="dialogInspectionReport" width="520px">
            <div class="express-current">
                当前质检报告：
                <span class="ns-text-color">{{ selectedInspectionReportName }}</span>
            </div>
            <div class="inspection-report-list">
                <div
                    v-for="item in inspectionReportList"
                    :key="item.value"
                    class="inspection-report-option"
                    :class="{ active: inspection_report_type == item.value }"
                    @click="selectInspectionReport(item.value)">
                    <div class="report-option-icon">
                        <i class="el-icon-document-checked"></i>
                    </div>
                    <div class="report-option-main">
                        <div class="report-option-name">{{ item.name }}</div>
                        <div class="report-option-desc">{{ item.desc }}</div>
                    </div>
                    <div class="report-option-check">
                        <i v-if="inspection_report_type == item.value" class="el-icon-check"></i>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogInspectionReport = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 配送方式 外卖 -->
        <!-- 		<el-dialog title="送达时间" :visible.sync="deliveryTime" width="400px">
			<el-form status-icon ref="ruleForm" label-width="100px">
				<el-form-item label="送达时间">
					<el-col :span="11">
						<el-time-picker format="HH:mm" value-format="HH:mm" placeholder="选择时间" :value="time" v-model="time" start="09:01"
						 end="21:01" @change="bindTimeChange"></el-time-picker>
					</el-col>
				</el-form-item>
				<el-form-item label="">
					<el-col :span="20">
						<div class="align-right">
							<el-button size="small" @click="deliveryTime = false">关闭</el-button>
							<el-button type="primary" size="small" @click="setDeliveryTime(siteDelivery.site_id)">确认选择</el-button>
						</div>
					</el-col>
				</el-form-item>
			</el-form>
		</el-dialog> -->

        <!-- 支付密码 -->
        <el-dialog title="使用余额" :visible.sync="dialogpay" width="350px">
            <template v-if="orderPaymentData.member_account.is_pay_password == 0">
                <p>为了您的账户安全,请您先设置的支付密码</p>
                <p>可到"客户中心","账号安全","支付密码"中设置</p>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dialogpay = false">暂不设置</el-button>
                    <el-button size="small" type="primary" @click="setPayPassword">立即设置</el-button>
                </span>
            </template>
            <el-form v-else status-icon ref="ruleForm" label-width="100px">
                <el-form-item label="支付密码" class="pay-password-item">
                    <!--添加一个不可见的input,欺骗浏览器自动填充-->
                    <el-input type="password" class="pay-password hide-password" :maxlength="6"></el-input>
                    <el-input type="password" class="pay-password" :maxlength="6" v-model="password"
                        @input="input"></el-input>
                </el-form-item>
                <p class="ns-text-color forget-password" @click="setPayPassword">忘记密码</p>
            </el-form>
        </el-dialog>

        <!--选择优惠券弹框-->
        <!-- <el-dialog title="选择优惠券" :visible.sync="dialogCoupon" width="50%">
			<el-table ref="couponTable" :data="siteCoupon.data" highlight-current-row @row-click="selectCoupon" class="cursor-pointer">
				<el-table-column label="" width="55">
					<template slot-scope="scope">
						<div class="disabled-selected-wrap">
							<el-radio v-model="couponRadio" :label="scope.row"><i></i></el-radio>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="coupon_name" label="名称" width="200"></el-table-column>
				<el-table-column label="优惠">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 'reward'">{{ scope.row.money }}</span>
						<span v-if="scope.row.type == 'discount'">{{ scope.row.discount }} 折</span>
					</template>
				</el-table-column>
				<el-table-column prop="use" label="使用"></el-table-column>
				<el-table-column prop="time" label="期限"></el-table-column>
			</el-table>
			<br />
			<div class="align-right">
				<el-button @click="dialogCoupon = false">取消</el-button>
				<el-button @click="saveCoupon()" type="primary">确认选择</el-button>
			</div>
		</el-dialog> -->
    </div>
</template>

<script>
import PicZoom from "vue-piczoom"
import detail from "./payment.js"
import GoodsInfo from "@/views/goods/cart/components/goods-info.vue"
import router from "@/router"
import cartAndOrder_price from "@/components/cartAndOrder/cartAndOrder_price.vue"
export default {
    name: "payment",
    components: {
        GoodsInfo,
        PicZoom,
        cartAndOrder_price
    },
    mounted() {
        // this.$refs.radio.$children.forEach((item) => {
        //     console.log(item)
        //    item.$refs.radio.removeAttribute("aria-hidden");
        // });
    },
    computed: {
        // 是否满足订单最低金额
        isOrderMinBuyMoney() {
            let price = Number(this.orderPaymentData.order_money) + this.freeGoodsMoney;
            return price < Number(this.orderPaymentData.min_buy_money)
        },
        // 换购商品数量上限
        freeGoodsLimit() {
            // {{Math.floor(goodsItem.num/goodsItem.get_goods_free.count) * exchengeItem.num > exchengeItem.limit ?  exchengeItem.limit: Math.floor(goodsItem.num/goodsItem.get_goods_free.count) * exchengeItem.num }}
            return (goodsItem, exchengeItem) => {
                return parseInt(exchengeItem.num);
            }
        },
        // 订单金额加上换购商品的金额
        computedPayMoney() {
            // return this.orderPaymentData.pay_money + this.freeGoodsMoney
            return this.orderPaymentData.pay_money + this.freeGoodsMoney
        },
        // 普通商品和换购商品的总金额
        commonGoodsAndExchangedGoodsComputedMoney() {
            return this.orderPaymentData.goods_money + this.freeGoodsMoney
        }
    },
    methods: {
        router() {
            return router
        },
        goodsInfoAdpter(item) {
            return {
                ...item,
                attr: item.goods_attr_format
            }
        },
        computedAllFreeGoodsMoney() {
            let free_goods_money = 0
            let freeGoodsList = this.orderPaymentData.shop_goods_list.goods_list.filter((ele) => ele.get_goods_free !== null && ele.num >= ele.get_goods_free.count)
            freeGoodsList.forEach((item) => {
                // 遍历单个商品中选中的换购商品
                item.get_goods_free.getFreeGoods.forEach((freeGoods) => {
                    if (freeGoods.checked) {
                        free_goods_money += (parseInt(freeGoods.num) * parseFloat(freeGoods.price));
                    }
                })
            })
            this.freeGoodsMoney = free_goods_money
        },
        goodsFreeChoice(freeGoods, free_index, goodsIndex, goods) {
            // 任选其一
            let max_num = goods.get_goods_free.goods_range
            if (freeGoods.checked) {
                freeGoods.checked = false
                this.computedAllFreeGoodsMoney()
                return
            }
            if (max_num === 1) {
                goods.get_goods_free.getFreeGoods.forEach((ele) => {
                    ele.checked = false
                })
                freeGoods.checked = true
            } else if (max_num > 1) {
                let checkedNum = goods.get_goods_free.getFreeGoods.filter((ele) => ele.checked).length
                if (checkedNum < max_num && freeGoods.checked === false) {
                    freeGoods.checked = !freeGoods.checked
                } else {
                    this.$message({
                        message: `最多可选${max_num}个商品！`,
                        type: "warning"
                    })
                }
            } else {
                freeGoods.checked = !freeGoods.checked
            }
            this.$forceUpdate()
            // 换购商品金额计算
            this.computedAllFreeGoodsMoney()
        },
        dd () {
            console.log('data',typeof this.orderCreateData.invoice_type)
            console.log(this.invoiceRadio)
        },
        returnShowFreeGoods(goodsItem){
            let bool1 = (goodsItem.get_goods_free&&goodsItem.get_goods_free.getFreeGoods&&goodsItem.get_goods_free.getFreeGoods.length>0);
            let bool2 = false;
            if(bool1){
                bool2 = goodsItem.get_goods_free.getFreeGoods.some(item=>goodsItem.num >= item.count);
            }
            if(bool1&&bool2){
                return true
            }
            return false
        },
        returnCouponText(item){
            if(item.type == 'reward'){
                return '一次性满减券'
            }else if(item.type == 'discount'){
                return '折扣券'
            }else if(item.type == 'no_threshold'){
                return '无门槛券'
            }else if(item.type == 'ladder_reward'){
                return '阶梯性满减券'
            }
        },
        verifyActiveGoods(info){ // 验证是否是活动商品
            let bool = true;
            let v_bool_1 = info.promotion_label === 'seckill';
            let v_bool_2 = info.promotion_label === 'discount';
            let v_bool_3 = info.promotion_label === 'wholesale';
            let v_bool_4 = info.is_getfree || info.get_free_goods;
            if(v_bool_1 || v_bool_2 || v_bool_3 || v_bool_4){
                bool = false;
            };
            return bool;
        },
        goodsPrice(goodsItem) {
            const { num, real_price, price, discount_price, original_price } = goodsItem;
            const qty = Number(num);
            const realPrice = Number(real_price);
            const currentPrice = Number(price);
            const discountPrice = Number(discount_price);
            const originalPrice = Number(original_price);

            // 确定用于比较的价格（划线价的候选值）
            let comparePrice = null;
            if (realPrice !== currentPrice) {
				comparePrice = currentPrice;
			}

            // 最终划线价：仅当实际价格低于比较价格时才设置
            const finalOriginalPrice = (comparePrice !== null && realPrice < comparePrice) ? comparePrice : 0;

            const totalReal = realPrice * qty;
            const totalOriginal = finalOriginalPrice * qty;
            const totalDiscount = (totalOriginal > 0 && totalReal > 0) ? totalOriginal - totalReal : 0;

            // 保留两位小数
            const round2 = (num) => Number(num.toFixed(2));
			let Obj = {
                real_price: round2(realPrice),
                total_real_price: round2(totalReal),
                original_price: round2(finalOriginalPrice),
                total_original_price: round2(totalOriginal),
                total_discount_price: round2(totalDiscount),
            };
            return Obj;
        },
    },
    watch: {
        "orderPaymentData.shop_goods_list.goods_list": {
            handler(val) {
                // 手动给换购选择商品添加一个checked属性
                val.forEach((ele) => {
                    if (ele.get_goods_free !== null) {
                        let num = ele.num;
                        // 获取换购商品可选数量
                        let goods_range = ele.get_goods_free.goods_range;
                        let sumNum = 1;
                        if(goods_range===0){
                            goods_range = 9999999;// 可选无上限
                        }
                        let findArr = ele.get_goods_free.getFreeGoods.filter(item=>num >= item.count);
                        ele.get_goods_free.getFreeGoods.forEach((freeGoods, index) => {
                            let findObj = findArr.find(item=>item.goods_id === freeGoods.goods_id);
                            if(findObj&&sumNum<=goods_range&&freeGoods.sale_control.is_member_by){
                                this.$set(freeGoods, "checked", true);
                                this.computedAllFreeGoodsMoney();
                                sumNum +=1;
                            }else{
                                this.$set(freeGoods, "checked", false)
                            }
                        })
                    }
                })
            }
        }
    },
    mixins: [detail]
}
</script>

<style lang="scss" scoped>
@import "./payment.scss";

.fulfillment-block {
    padding-bottom: 18px;
}

.fulfillment-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding-top: 14px;
}

.fulfillment-card {
    min-height: 96px;
    padding: 16px 18px;
    border: 1px solid #e8ecf2;
    border-radius: 6px;
    background: #fbfcfd;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        border-color: $base-color;
        background: #fff;
        box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
    }

    &.is-empty {
        border-style: dashed;
        background: #fffdf8;
    }
}

.inspection-report-card {
    gap: 16px;
}

.fulfillment-card-main {
    min-width: 0;
    display: flex;
    align-items: center;
}

.fulfillment-icon {
    width: 42px;
    height: 42px;
    margin-right: 12px;
    border-radius: 6px;
    background: #f1fff7;
    color: $base-color;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 22px;
}

.fulfillment-content {
    min-width: 0;
}

.fulfillment-label {
    color: #909399;
    font-size: 12px;
    line-height: 1.2;
}

.fulfillment-value {
    margin-top: 6px;
    color: #222;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fulfillment-desc {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
}

.fulfillment-extra {
    margin-left: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #909399;
    flex-shrink: 0;
}

.express-current {
    margin-bottom: 12px;
    padding: 10px 12px;
    border-radius: 4px;
    background: #f7f8fa;
    color: #606266;

    span {
        font-weight: 600;
    }
}

.express-empty {
    min-height: 180px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    color: #909399;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    i {
        margin-bottom: 10px;
        font-size: 32px;
        color: #c0c4cc;
    }

    div {
        color: #303133;
        font-weight: 600;
    }

    p {
        margin: 8px 0 0;
        font-size: 12px;
    }
}

.inspection-report-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.inspection-report-option {
    min-height: 74px;
    padding: 14px 16px;
    border: 1px solid #e8ecf2;
    border-radius: 6px;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;

    &:hover {
        border-color: $base-color;
        background: #fbfffd;
    }

    &.active {
        border-color: $base-color;
        background: #f1fff7;
    }
}

.report-option-icon {
    width: 38px;
    height: 38px;
    margin-right: 12px;
    border-radius: 6px;
    background: #f2f4f7;
    color: #606266;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
}

.inspection-report-option.active .report-option-icon {
    background: #fff;
    color: $base-color;
}

.report-option-main {
    min-width: 0;
    flex: 1;
}

.report-option-name {
    color: #222;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
}

.report-option-desc {
    margin-top: 5px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
}

.report-option-check {
    width: 28px;
    height: 28px;
    margin-left: 12px;
    border-radius: 50%;
    border: 1px solid #dcdfe6;
    color: transparent;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
}

.inspection-report-option.active .report-option-check {
    border-color: $base-color;
    color: #fff;
    background: $base-color;
}

.free-goods-content {
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    //border: 1px solid red;
    overflow-y: auto;
    display: flex;
    gap: 20px;
    margin-bottom: 20px;

    .goods-content {
        padding: 10px;
        width: 180px;
        flex-shrink: 0;
        position: relative;
    }

    .goods-content-checked {
        border: 2px solid $base-color;
        border-radius: 3px;
    }

    .freeGoodsAttrItem {
        line-height: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
    }
}
.position_text{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
    >span{
        font-size: 28px;
        color: #fff;
    }
}
/* For Webkit browsers */
.free-goods-content::-webkit-scrollbar {
    width: 10px;
}

.free-goods-content::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
}

.free-goods-content::-webkit-scrollbar-thumb {
    background-color: $base-color;
    border-radius: 6px;
    min-width: 30px;
    /* 设置滚动条的最小宽度 */
    //&:hover {
    //    background: $base-color;
    //}
}

.free-goods-content::-webkit-scrollbar-track {
    width: 20px;
    border-radius: 10px;
    background: #888;
    //background-color: #1890ff;
}
.price_new{
	display: flex;
	flex-direction: column;
	gap: 6px;
	height: 100px;
	justify-content: center;
	
	div{
		line-height: 1;
		span{
			line-height: 1;
		}
	}
	.class_1{
		display: flex;
		align-items: baseline;
		>span:nth-child(1){
			font-size: 12px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(2){
			font-size: 14px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(3){
			font-size: 12px;
			color: #999;
		}
	}
	.class_2{
		display: flex;
		align-items: baseline;
		>span:nth-child(1){
			font-size: 12px;
			color: #999;
			font-weight: bold;
			text-decoration: line-through 1px;
		}
		>span:nth-child(2){
			font-size: 14px;
			color: #999;
			font-weight: bold;
			text-decoration: line-through 1px;
		}
		>span:nth-child(3){
			font-size: 12px;
			color: #999;
		}
	}
}
.price_new_2{
	display: flex;
	flex-direction: column;
	gap: 6px;
	height: 100px;
	justify-content: center;
	
	div{
		line-height: 1;
		span{
			line-height: 1;
		}
	}
	.class_1{
		display: flex;
		align-items: baseline;
		>span:nth-child(1){
			font-size: 12px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(2){
			font-size: 14px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(3){
			font-size: 12px;
			color: #999;
		}
	}
	.class_2{
		display: flex;
		flex-direction: column;
		gap: 6px;
		>div:nth-child(2){
			display: flex;
			align-items: center;
			>span{
				color: red;
                font-weight: bold;
			}
		}
		>div:nth-child(1){
			display: flex;
			align-items: baseline;
			>span:nth-child(1){
				font-size: 12px;
				color: #999;
				font-weight: bold;
				text-decoration: line-through 1px;
			}
			>span:nth-child(2){
				font-size: 14px;
				color: #999;
				font-weight: bold;
				text-decoration: line-through 1px;
			}
			>span:nth-child(3){
				font-size: 12px;
				color: #999;
			}
		}
	}
}
</style>
